import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { IPcr } from '../../pcr/store/pcr.types'
import { getDestinationAddressSelector } from '../selectors/destinationAddress.selectors'
import { DestinationAddressConstants } from '../store/destinationAddress.constants'
import { setResponse } from '../store/destinationAddress.actions'
import { IDispositionState } from '../store/destinationAddress.types'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* saveDestinationAddress() {
  const disposition: IDispositionState = yield select(getDestinationAddressSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    const pcrDocUpdated = { ...pcrDoc, disposition }
    try {
      const response: string = yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
      yield put(setResponse(response))
    } catch (e) {
      yield put(throwPcrException(`saveDestinationAddress() error: ${e}`))
    }
  }
}

export function* saveDestinationAddressSaga() {
  yield takeLatest(
    [
      DestinationAddressConstants.SET_TYPE,
      DestinationAddressConstants.SET_OTHER_TYPE,
      DestinationAddressConstants.SET_LOCATION,
      DestinationAddressConstants.SET_COUNTY,
      DestinationAddressConstants.SET_RECEIVING_RN,
      DestinationAddressConstants.SET_RECEIVING_MD,
      DestinationAddressConstants.SET_RECEIVING_USNG,
      DestinationAddressConstants.SET_RECEIVING_GPS_N,
      DestinationAddressConstants.SET_RECEIVING_GPS_E,
      DestinationAddressConstants.SET_TRANSPORT_MODE,
      DestinationAddressConstants.SET_TRANSPORT_MODE_PNNV,
      DestinationAddressConstants.SET_ADDRESS_LINE1,
      DestinationAddressConstants.SET_ADDRESS_LINE2,
      DestinationAddressConstants.SET_APT_SUITE_ROOM,
      DestinationAddressConstants.SET_MILE_POST_MAJOR_ROADWAY,
      DestinationAddressConstants.SET_CROSS_STREET_DIRECTIONS,
      DestinationAddressConstants.SET_CITY,
      DestinationAddressConstants.SET_STATE,
      DestinationAddressConstants.SET_ZIP,
      DestinationAddressConstants.SET_COUNTRY,
      DestinationAddressConstants.SET_CENSUS_TRACT,
      DestinationAddressConstants.SAVE_DESTINATION_ADDRESS,
      DestinationAddressConstants.SET_HOSPITAL_IN_PATIENT_DESTINATION,
      DestinationAddressConstants.SET_MODE_DESCRIPTORS,
      DestinationAddressConstants.SET_COMMENT,
      DestinationAddressConstants.SET_DESTINATION_BASIS,
      DestinationAddressConstants.SET_DESTINATION_GRID,
      DestinationAddressConstants.SET_CAPABILITIES,
    ],
    performWithMutexHOG,
    saveDestinationAddress
  )
}
